module.exports = __webpack_public_path__ + "static/media/ic_caret_up.8a16ee7a.svg";